/*###########################################################################
// Forms
//#########################################################################*/

const forms = {
	config: {

	},

	elements: {},

	init() {
		const self = this

	}
}

initComponent(() => {
	forms.init()
})
